import { render } from "./ProductChooserLiveTest.vue?vue&type=template&id=2d2b70de&scoped=true"
import script from "./ProductChooserLiveTest.vue?vue&type=script&lang=js"
export * from "./ProductChooserLiveTest.vue?vue&type=script&lang=js"

import "./ProductChooserLiveTest.vue?vue&type=style&index=0&id=2d2b70de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2b70de"]])

export default __exports__